/**
 * Trạng thái nộp dự toán
 */
export default {
   /// <summary>
  /// Thất bại
  /// </summary>
  Failed: -1,
  
  /// <summary>
  /// Mặc định
  /// </summary>
  Default :0,
  
  /// <summary>
  /// Đang xử lý
  /// </summary>
  InProgress: 1,

  /// <summary>
  /// Thành công
  /// </summary>
  Success : 2
};
